import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Heading } from "../../components/styledConstants";
import Filters from "./Components/Filters";
import SocietiesTable from "./Components/SocietiesTable";
import AddSocietyModal from "./Components/AddSocietyModal";
import { getSocieties } from "../../utils/api";
import config from "../../utils/config";
import CsvDownApi from "../../components/ExportFiles/CsvDownApi";

const SocietyPartnerHub = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [societies, setSocieties] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({ societyNameFilter: "" });
  const [debouncedFilter, setDebouncedFilter] = useState(filters.societyNameFilter);
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const csvHeaders = [
    { label: "Organization Name", key: "orgName" },
    { label: "Owner Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Mobile No", key: "mobileNo" },
    { label: "Referral Id", key: "referralId" },
    { label: "Program Manager Name", key: "programManagerName" },
    { label: "Program Manager Code", key: "programManagerCode" },
    { label: "Status", key: "status" },
  ];
  // 🔹 Debounce filter input
  useEffect(() => {
    const handler = setTimeout(() => {
      if (filters.societyNameFilter.length === 0 || filters.societyNameFilter.length >= 3) {
        setDebouncedFilter(filters.societyNameFilter);
        setPage(0); // Reset to first page
      }
    }, 500); // Wait 500ms after user stops typing

    return () => clearTimeout(handler);
  }, [filters]);

  const fetchSocieties = async () => {
    setLoading(true);
    try {
      const payload = {
        name: debouncedFilter.trim(),
        pageNo: page,
        pageSize: itemsPerPage,
      };
      const res = await getSocieties(payload);

      if (res?.data?.code === "0000") {
        const data = res?.data?.data;
        setSocieties(data?.data || []);
        setTotalPages(data?.totalPages || 0);
        setTotalRecords(data?.totalRecords || 0);
      } else {
        throw new Error(res?.data?.message || "Failed to fetch societies");
      }
    } catch (err) {
      console.error("Error fetching societies:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Call API whenever debounced filter, page, or itemsPerPage changes
  useEffect(() => {
    fetchSocieties();
  }, [debouncedFilter, page, itemsPerPage]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  const csvParams = {
    name: debouncedFilter.trim(),
    pageNo: page,
    pageSize: itemsPerPage,
  };
  return (
    <>
      <div className="flex flex-center space-between mb10">
        <Heading size="xxl">Organization List</Heading>
        {societies.length > 0 && (
          <CsvDownApi
            headers={csvHeaders}
            url={`${config.apis.societyPartnerHub.GET_ALL_SOCIETIES}`} // use your actual getSocieties endpoint
            params={csvParams}
            method="post"
            reportName="OrganizationList.csv"
            title="Download CSV"
          />
        )}
      </div>
      <Box
        sx={{
          p: 3,
          maxWidth: 1200,
          margin: "auto",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Filters handleOpenModal={() => setAddModalOpen(true)} filters={filters} setFilters={setFilters} />
        {loading ? (
          <CircularProgress />
        ) : (
          <SocietiesTable
            data={societies}
            pagination={{
              currentPage: page + 1,
              totalPages,
              totalRecords,
              itemsPerPage,
              onPageChange: (newPage) => setPage(newPage - 1),
              onItemsPerPageChange: handleItemsPerPageChange,
            }}
          />
        )}
      </Box>
      <AddSocietyModal open={addModalOpen} handleClose={() => setAddModalOpen(false)} />
    </>
  );
};

export default SocietyPartnerHub;
